import type { ElementType } from 'react';

import FormLabel from '../FormLabel';
import { useControlledField } from './ControlledFieldContext';

type ControlledFieldLabelProps<C extends ElementType> = Omit<
  PolymorphicComponentProp<C>,
  'htmlFor'
>;

const ControlledFieldLabel = <C extends React.ElementType = typeof FormLabel>({
  as,
  ...props
}: ControlledFieldLabelProps<C>) => {
  const { field } = useControlledField();
  const Component = (as || FormLabel) as ElementType;
  return <Component htmlFor={field.name} {...props} />;
};

export default ControlledFieldLabel;
